import { SignUpVerifyActionTypes } from './types/actions'
import { SignUpVerifyState } from './types/reducer'
import {
  USER_SIGN_UP_VERIFY,
  USER_SIGN_UP_VERIFY_SUCCESS,
  USER_SIGN_UP_VERIFY_ERROR,
  SIGN_UP_VERIFY_CLEAN_UP,
  RESEND_CODE,
  RESEND_CODE_SUCCESS,
  RESEND_CODE_ERROR,
} from './constants'

export const initialState: SignUpVerifyState = {
  isLoading: false,
  success: false,
  resendSuccess: false,
}

const reducer = (
  state: SignUpVerifyState = initialState,
  action: SignUpVerifyActionTypes,
): SignUpVerifyState => {
  switch (action.type) {
    case USER_SIGN_UP_VERIFY:
      return { ...state, isLoading: true }
    case USER_SIGN_UP_VERIFY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
      }
    case USER_SIGN_UP_VERIFY_ERROR:
      return {
        ...state,
        isLoading: false,
        success: false,
      }
    case SIGN_UP_VERIFY_CLEAN_UP:
      return {
        ...state,
        ...initialState,
      }
    case RESEND_CODE:
      return { ...state, isLoading: true }
    case RESEND_CODE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        resendSuccess: true,
      }
    case RESEND_CODE_ERROR:
      return {
        ...state,
        isLoading: false,
        resendSuccess: false,
      }
    default:
      return state
  }
}

export default reducer
